import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { States, mainviewActions } from '../../helpers/constants';

import { editUser } from '../../actions/app/app';
import { hideModal } from '../../actions/modal/modal';

const EditUserForm = () => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        mainviewProps = useSelector(store => store.mainview),
        formik = useFormik({
          initialValues: {
            email: mainviewProps.editedUserAccount.user?.email,
            phone: mainviewProps.editedUserAccount.phone === null ? '' : mainviewProps.editedUserAccount.phone,
            postal_address: mainviewProps.editedUserAccount.postal_address,
            postal_suburb: mainviewProps.editedUserAccount.postal_suburb,
            postal_state: mainviewProps.editedUserAccount.postal_state,
            postal_code: mainviewProps.editedUserAccount.postal_code === null ? '' : mainviewProps.editedUserAccount.postal_code,
            group_name: mainviewProps.editedUserAccount.group_name,
            first_name: mainviewProps.editedUserAccount.user?.first_name,
            last_name: mainviewProps.editedUserAccount.user?.last_name,
            is_admin: mainviewProps.editedUserAccount.is_admin,
            is_akfstaff: mainviewProps.editedUserAccount.is_akfstaff,
            is_licenseduser: mainviewProps.editedUserAccount.is_licenseduser,
            is_active: mainviewProps.editedUserAccount.user.is_active
          },
          validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Email address is required'),
            first_name: Yup.string().required('First name is required'),
            last_name: Yup.string().required('Surname is required'),
            phone: Yup.string().matches(/^\d+$/, 'Phone number can only contain numbers'),
            postal_code: Yup.string().matches(/^\d+$/, 'Postal code can only contain numbers')
          }),
          onSubmit: values => {
            const formObject = {
              user: {}
            };
            
            if (formik.initialValues.phone !== values.phone) formObject.phone = (values.phone === '' ? null : values.phone); // Server does not accept string "", so need to pass null if user removes info
            if (formik.initialValues.postal_address !== values.postal_address) formObject.postal_address = values.postal_address;
            if (formik.initialValues.postal_code !== values.postal_code) formObject.postal_code = (values.postal_code === '' ? null : values.postal_code);
            if (formik.initialValues.postal_state !== values.postal_state) formObject.postal_state = values.postal_state;
            if (formik.initialValues.postal_suburb !== values.postal_suburb) formObject.postal_suburb = values.postal_suburb;
            if (formik.initialValues.group_name !== values.group_name) formObject.group_name = values.group_name;

            if (formik.initialValues.first_name !== values.first_name) formObject.user.first_name = values.first_name;
            if (formik.initialValues.last_name !== values.last_name) formObject.user.last_name = values.last_name;
            if (formik.initialValues.email !== values.email) formObject.user.email = values.email;

            if (formik.initialValues.is_admin !== values.is_admin) formObject.is_admin = values.is_admin;
            if (formik.initialValues.is_akfstaff !== values.is_akfstaff) formObject.is_akfstaff = values.is_akfstaff;
            if (formik.initialValues.is_admin !== values.is_licenseduser) formObject.is_licenseduser = values.is_licenseduser;
            if (formik.initialValues.is_active !== values.is_active) formObject.user.is_active = values.is_active;
              
            dispatch(editUser(mainviewProps.editedUserAccount.user.id, JSON.stringify(formObject)));
          }
        }),
        isAdmin = appProps.loggedInUser?.is_admin;

  const _modalClose = () => {
    if (formik.dirty)
      if (!window.confirm('You have unsaved changes. Closing will lose any changes.\nAre you sure you wish to close?')) return false;

    dispatch({ type: mainviewActions.EDIT_USER_ACCOUNT_CANCEL });
    dispatch(hideModal());
  }
  
  return (
    <>
      <span className="modal__close" onClick={ () => _modalClose() }>&times;</span>
      
      <form className="form form--restricted" onSubmit={ formik.handleSubmit }>
        
        <div className="form__group">
          <label className="form__label">Account information</label>
          <input className="form__input" type="email" value={ formik.values.email } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="email" id="email" placeholder="Enter your email address" />
          { formik.touched.email &&  formik.errors.email ? (<span className="form__error-item">{ formik.errors.email }</span>) : ''}
        </div>

        <div className="form__group">
          <label className="form__label">Your information</label>
          <input className="form__input" type="text" value={ formik.values.first_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="first_name" id="first_name" placeholder="Enter your first name" />
          { formik.touched.first_name && formik.errors.first_name ? (<span className="form__error-item">{ formik.errors.first_name }</span>) : ''}
          <input className="form__input" type="text" value={ formik.values.last_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="last_name" id="last_name" placeholder="Enter your surname" />
          { formik.touched.last_name && formik.errors.last_name ? (<span className="form__error-item">{ formik.errors.last_name }</span>) : ''}
          <input className="form__input" type="tel" value={ formik.values.phone } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="phone" id="phone" placeholder="Enter your phone number" />
          { formik.touched.phone && formik.errors.phone ? (<span className="form__error-item">{ formik.errors.phone }</span>) : ''}
        </div>

        <div className="form__group">
          <label className="form__label">Address</label>
          <input className="form__input" type="text" value={ formik.values.postal_address } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_address" id="postal_address" placeholder="Enter your address" />
          <input className="form__input" type="text" value={ formik.values.postal_code } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_code" id="postal_code" placeholder="Enter your postal code" />
          { formik.touched.postal_code && formik.errors.postal_code ? (<span className="form__error-item">{ formik.errors.postal_code }</span>) : ''}
          <input className="form__input" type="text" value={ formik.values.postal_suburb } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_suburb" id="postal_suburb" placeholder="Enter your suburb" />
          <div className="form__select-container">
            <select className="form__select" onChange={ formik.handleChange } value={ formik.values.postal_state } onBlur={ formik.handleBlur } name="postal_state" id="postal_state">
              {
                Object.values(States).map((state, key) => (
                  <option value={ state } key={ key }>{ state }</option>
                ))
              }
            </select>
          </div>
        </div>

        {
          isAdmin ? 
          (
            <>
              {
                mainviewProps.editedUserAccount.user.id !== appProps.loggedInUser.user.id && // Prevent people from locking the account they're logged in to
                <div className="form__group">
                  <label htmlFor="is_active" className="form__label">Active user?</label>
                  <div className="form__select-container">
                    <select className="form__select" onChange={ formik.handleChange } value={ formik.values.is_active } onBlur={ formik.handleBlur } name="is_active" id="is_active">
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
              }
              <div className="form__group">
                <label htmlFor="is_admin" className="form__label">Admin privilege?</label>
                <div className="form__select-container">
                  <select className="form__select" onChange={ formik.handleChange } value={ formik.values.is_admin } onBlur={ formik.handleBlur } name="is_admin" id="is_admin">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div className="form__group">
                <label htmlFor="is_akfstaff" className="form__label">AKF staff member?</label>
                <div className="form__select-container">
                  <select className="form__select" onChange={ formik.handleChange } value={ formik.values.is_akfstaff } onBlur={ formik.handleBlur } name="is_akfstaff" id="is_akfstaff">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div className="form__group">
                <label htmlFor="is_licenseduser" className="form__label">Is the user licensed?</label>
                <div className="form__select-container">
                  <select className="form__select" onChange={ formik.handleChange } value={ formik.values.is_licenseduser } onBlur={ formik.handleBlur } name="is_licenseduser" id="is_licenseduser">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
            </>
          ) : null
        }

        <div className="form__group">
          <label className="form__label">Group Name</label>
          <input className="form__input" type="text" value={ formik.values.group_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="group_name" id="group_name" placeholder="Enter your group name" />
        </div>

        <div className="form__button-group">
          <span className="form__button button button--hollow" onClick={ () => _modalClose(true) }>Cancel</span>
          <button type="submit" className="form__button button">Update account</button>
        </div>
        
      </form>
    </>
  );

}

export default EditUserForm;